module.exports = __webpack_public_path__ + "static/media/location-pickup-box.f37bfa7e.png";